import React, {useEffect} from "react";
import Header from "../components/Header.js";
import {FormattedMessage} from 'react-intl';
import * as StorageService from "../services/StorageService.js";
import {FIREBASE_SCREEN_NAMES, HEADER_SIZE, LOCALSTORAGE_ITEMS} from "../util/Constants.js";
import analyticsLogEvent from "../services/FirebaseService";
import ScheduleCard from "../components/ScheduleCard";

function Schedules() {
    const shopDetails = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)) : null;
    const weekOpenSchedule = shopDetails ? (typeof shopDetails.merchantConfig !== "undefined" ? shopDetails.merchantConfig.weekOpenSchedule?.schedule : null) : false;
    const weekDeliverySchedule = shopDetails ? (typeof shopDetails.merchantConfig !== "undefined" ? shopDetails.merchantConfig.weekDeliverySchedule?.schedule : null) : false;
    const weekPickupSchedule = shopDetails ? (typeof shopDetails.merchantConfig !== "undefined" ? shopDetails.merchantConfig.weekPickupSchedule?.schedule : null) : false;
    const weekReservationSchedule = shopDetails ? (typeof shopDetails.merchantConfig !== "undefined" ? shopDetails.merchantConfig.weekReservationSchedule?.schedule : null) : false;
    useEffect(() => {
        analyticsLogEvent("screen_view", {
            firebase_screen: FIREBASE_SCREEN_NAMES.SCHEDULES,
            firebase_screen_class: FIREBASE_SCREEN_NAMES.SCHEDULES
        });
    }, []);

    function getDayName(index) {
        const days = [
            <FormattedMessage id="Monday"/>,
            <FormattedMessage id="Tuesday"/>,
            <FormattedMessage id="Wednesday"/>,
            <FormattedMessage id="Thursday"/>,
            <FormattedMessage id="Friday"/>,
            <FormattedMessage id="Saturday"/>,
            <FormattedMessage id="Sunday"/>,
        ];
        return days[index];
    }

    function getDaySchedule(daySchedule) {
        if (daySchedule) {
            return daySchedule.map((day) => ({
                openFrom: day.openFrom,
                openUntil: day.openUntil,
            }));
        }else {
            return [];
        }

    }

    function getScheduleData(schedule) {
        return schedule?.map((day, index) => ({
            dayName: getDayName(index),
            isOpen: day.isOpen,
            openFrom: day.openFrom,
            openUntil: day.openUntil,
            daySchedule: getDaySchedule(day.daySchedule),
        }));
    }

    const weekPickupScheduleData = getScheduleData(weekPickupSchedule);
    const weekDeliveryScheduleData = getScheduleData(weekDeliverySchedule);
    const weekOpenScheduleData = getScheduleData(weekOpenSchedule);
    const weekReservationScheduleData = getScheduleData(weekReservationSchedule);

    return (
        <>
            <Header
                headerSize={HEADER_SIZE.SMALL}
                headerTitle={<FormattedMessage id="Schedules"/>}
                hasBackBtn={true}
                hasModal={false}
            />


            <main className="page-content schedules-page-content without-actionsbar">
               <ScheduleCard
                    scheduleData={weekOpenScheduleData}
                    title={<FormattedMessage id="OnLocationSchedule"/>}
                />

              <ScheduleCard
                    scheduleData={weekDeliveryScheduleData}
                    title={<FormattedMessage id="DeliverySchedule"/>}
                />

                 <ScheduleCard
                    scheduleData={weekPickupScheduleData}
                    title={<FormattedMessage id="PickupSchedule"/>}
                />

                <ScheduleCard
                    scheduleData={weekReservationScheduleData}
                    title={<FormattedMessage id="ReservationSchedule"/>}
                />

            </main>
        </>
    );
}

export default Schedules;
